.Layout {
  min-height: 100vh;
  background: linear-gradient(180deg, var(--qs-color-ground) 0%, var(--qs-color-surface) 100%);
  color: var(--qs-color-text);
  transition: background var(--qs-motion-dur-fade) ease, color var(--qs-motion-dur-fade) ease;
}
